import React from 'react';
import { Link } from 'react-router-dom';

const HowToUse = () => {
  // Corrected the href paths by adding the '/app' prefix.
  const cards = [
    { title: '請求書CSVアップロード', href: '/app/support/how-to-use/invoice-upload' },
    { title: '顧客CSVアップロード', href: '/app/support/how-to-use/customer-upload' },
    { title: '顧客データ削除', href: '/app/support/how-to-use/customer-delete' },
    { title: 'ご契約内容', href: '/app/support/how-to-use/subscription' },
    { title: 'Billwave設定', href: '/app/support/how-to-use/billwave-settings' },
    { title: 'お客様情報', href: '/app/support/how-to-use/customer-info' },
    { title: 'チーム管理', href: '/app/support/how-to-use/team-management' },
    { title: 'アクティビティ', href: '/app/support/how-to-use/activity' },
  ];

  return (
    <div className="bg-white p-8 w-full max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-6 pb-2 border-b-2 border-gray-200">
        使い方
      </h1>
      <p className="text-gray-700 mb-6">
        各機能の使い方については、以下の項目をクリックしてください。
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {cards.map((card, index) => (
          <Link
            key={index}
            to={card.href}
            className="block p-6 bg-gray-50 border border-gray-200 rounded-lg shadow-sm hover:bg-gray-100 hover:shadow-md transition-all duration-200 text-center"
          >
            <div className="font-semibold text-lg text-gray-800">
              {card.title}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HowToUse;
